import { GlobalState } from '..';

export const selectCart = ({ cart }: GlobalState) => cart;
